import React from 'react';
import { AiOutlineEdit } from 'react-icons/ai';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { useCurrent } from '../../../hooks';
import { getLangText } from '../../../utils/global';

const ListGroupsItem = ({ item, index, editHandeler, deleteHandeler }) => {
    const { currentLangId } = useCurrent();
    const [t] = useTranslation('global');
    const groupName = getLangText(item?.groupName, currentLangId) || t('vendors.noData');
    const groupDescription = getLangText(item?.groupDesc, currentLangId) || t('vendors.noData');

    return (
        <tr className='border-b border-slate-100 text-sm text-slate-600 transition-colors hover:bg-indigo-50/60'>
            <td className='px-3 py-3 text-center font-medium text-slate-500'>{index}</td>
            <td className='px-3 py-3 font-medium text-slate-700'>{groupName}</td>
            <td className='px-3 py-3'>
                <span className='block max-w-[360px] whitespace-pre-wrap'>{groupDescription}</span>
            </td>
            <td className='px-3 py-3 text-center'>
                <span
                    className={`inline-flex min-w-[92px] justify-center rounded-full px-3 py-1 text-xs font-semibold ${
                        item?.isActive
                            ? 'bg-emerald-100 text-emerald-700'
                            : 'bg-slate-200 text-slate-600'
                    }`}
                >
                    {item?.isActive ? t('product.active') : t('product.inactive')}
                </span>
            </td>
            <td className='px-3 py-3'>
                <div className='flex items-center justify-center gap-2'>
                    <button
                        type='button'
                        className='rounded-lg border border-slate-200 p-2 text-slate-500 transition-colors hover:border-indigo-200 hover:bg-indigo-50 hover:text-indigo-700'
                        title={t('common.edit')}
                        onClick={() => editHandeler(item._id)}
                    >
                        <AiOutlineEdit size={18} />
                    </button>

                    <button
                        type='button'
                        className='rounded-lg border border-slate-200 p-2 text-slate-500 transition-colors hover:border-red-200 hover:bg-red-50 hover:text-red-600'
                        title={t('common.delete')}
                        onClick={() => deleteHandeler(item._id)}
                    >
                        <RiDeleteBin6Line size={18} />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default ListGroupsItem;
